module.exports = __webpack_public_path__ + "static/media/starter-solana.73f5e3ae.svg";